module.exports = __webpack_public_path__ + "img/berechnung_1.5f7854c5.png";